module.exports = __webpack_public_path__ + "img/logo_lh_french.28bdbb22.png";